import { InsightsArchived } from "shared/resources";

import type { InsightsLandingPageItem } from "..";

export function isInsightsArchived(
  item: InsightsLandingPageItem
): item is InsightsArchived {
  return item instanceof InsightsArchived;
}
